module.exports = __webpack_public_path__ + "img/reset.9a724729.svg";